// extracted by mini-css-extract-plugin
export default {"loaderContainer":"NotificationsManagement_loaderContainer__IW1du","info":"NotificationsManagement_info__xl0VG","description":"NotificationsManagement_description__pxwo-"};